<template lang="pug">
.homepageSection7Component(id="command")
  .sectionContainer
    .title {{ data.title }}
    img.bg(src="assets/images/homepage/section7-bg1.svg")
    .items
      .item(
        v-for="(item, index) in data.items"
        :key="index"
        :class="`_${index + 1}`"
      )
        img.img(
          :src="item.img"
          data-aos="zoom-in"
        )
        .hint
          .title {{ item.title }}
          .text(v-html="item.text")
</template>

<script>
import homepageData from '@/mocks/homepage.json'

export default {
  setup () {
    const data = homepageData.section7

    return {
      data
    }
  }
}
</script>

<style lang="sass" scoped>
.homepageSection7Component
  .sectionContainer
    position: relative

    > .title
      position: absolute
      top: 51%
      left: 50%
      text-align: center
      font-family: GolosTextWebBold, serif
      font-size: clamp(32px, 3.1vw, 48px)
      color: $cDarkBlue
      line-height: 1.15
      width: 540px
      transform: translate(-50%, -50%)
      @media (max-width: $padWidth)
        font-size: 38px
        position: static
        transform: initial
        width: initial
        margin-bottom: 20*$u
      @media (max-width: $XXSWidth)
        font-size: 30px
        margin-bottom: 10*$u
    .bg
      width: 79%
      margin: 0 auto
      display: block
      @media (max-width: $padWidth)
        display: none

    .items
      @media (max-width: $padWidth)
        width: 100vw
        margin-left: -#{$appSidePaddingMobile}
        padding: 0 $appSidePaddingMobile 5*$u
        display: flex
        @include invisible-scrollbar
        @include gap(5*$u)
      .item
        position: absolute
        width: 10%
        @media (max-width: $padWidth)
          display: flex
          flex-direction: column
          width: 280px
          flex-shrink: 0
          position: static
        &:hover
          .hint
            opacity: 1
            pointer-events: initial
        &._1
          top: 4%
          left: 47%
          .hint
        &._2
          top: 26%
          left: 19%
          .hint
            left: 0
            transform: initial
        &._3
          top: 32%
          left: 74%
          .hint
            left: initial
            right: 0
            transform: initial
        &._4
          top: 70%
          left: 23%
          .hint
            left: 0
            transform: initial
        &._5
          top: 75%
          left: 61%
          .hint
            left: 0
            transform: initial

        .img
          display: block
          width: 100%
          @media (max-width: $padWidth)
            width: 100px
            margin: 0 auto -50px
            position: relative
            z-index: 10
            border: 2px solid $cWhite
            border-radius: 50%

        .hint
          opacity: 0
          transition: 0.5s
          pointer-events: none
          position: absolute
          z-index: 1
          top: 100%
          left: 50%
          width: 500px
          background: #334A8C
          color: $cWhite
          border-radius: $brXL
          padding: 7*$u 8*$u
          transform: translate(-50%, 0)
          box-shadow: 0 2*$u 5*$u rgba( #25408E19, 0.1)
          @media (max-width: $padWidth)
            opacity: 1
            pointer-events: initial
            width: 100% !important
            position: static
            transform: initial
            padding: 16*$u 5*$u 4*$u
            flex: 1 0 1px

          .title
            font-family: GolosTextWebDemiBold, serif
            margin-bottom: 3*$u
            font-size: 18px
            @media (max-width: $padWidth)
              text-align: center

          .text
            font-size: 14px
            display: flex
            flex-direction: column
            @include gap(2*$u, 'column')
</style>
